// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-radar';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M9 .936v16.56M1.44 4.32l15.12 9.144m0-9.144L1.44 13.536M9 .576l7.56 3.744v9.216L9 17.496l-7.56-4.032V4.32z' />
    <path d='m9 3.96 4.392 2.376v5.184L9 14.04l-4.392-2.376V6.336z' />
  </g>
);

export const viewBox = '0 0 18 18';
